import { render, staticRenderFns } from "./TwitterFollow.vue?vue&type=template&id=217d1d96&"
import script from "./TwitterFollow.vue?vue&type=script&lang=ts&"
export * from "./TwitterFollow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports